<template>
    <div>
        <Breadcrumbs main="Services" title="Edit Save As You Spend"/>
        <!-- <div v-if="routeName === 'save-as-you-spend'">
          <comingSoon/>
        </div> -->
        <!-- Container-fluid starts-->
        <div v-if="loading" class="loader-12"></div>
        <div v-else class="container-fluid">
            <section class="header-section">
              <div class="row">
                <div class="col-xl-5 d-flex justify-content-between align-items-center col-md-4 col-sm-12">
                <h3 class="header-text">Edit Configuration</h3>
                </div>
                <div class="col-xl-7 col-md-8 col-sm-12">
                  <div class="account-section" @click="showModal = !showModal">
                    <div>
                      <span class="account-number"><img class="mr-2" src="@/assets/TAJimages/wallet-icon-2.png"/>{{value.accountNumber}}</span>
                      <span class="ml-3 account-name">{{value.accountName}}</span>
                    </div>
                    <div>
                      <span class="account-amount">{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(value.availableBalance)}}</span>
                      <span class="ml-3 badge badge-pill badge-custom">Tier {{value.kycLevel}} {{value.accountType}}</span>
                      <span class="ml-2"><img src="@/assets/TAJimages/arrow-down-2.png"/></span>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <!--custom modal -->
            <transition>
                <section class="d-flex justify-content-end mt-4 custom-modal" v-if="showModal">
                    <div class="card shadow-lg" style=" border-radius:5px;">
                        <div class="" v-for="account in userAccounts" :key="account.id" @click="selectAccount(account)">
                            <div class="d-flex justify-content-between custom-modal-items">
                                <span>{{account.accountNumber}}</span>
                                <span>{{account.accountName}}</span>
                                <span>{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(account.availableBalance)}}</span>
                            </div>
                        </div>
                    </div>
                </section>
            </transition>
            
            <section class="body-wrapper">
             <p class="header-subtext">Enter amount to save for transactions under these categories</p>
             <div class="row" style="margin-top: 40px">
                 <div class="col-md-2">
                     <div class="card side-controller">
                         <div class="card-body">
                            <h3 class="config-type-text">Config Type</h3>
                            <div class="button-group py-5">
                                <button @click="configType('Flat Fee')" type="button" :class="isConfigType === 'Flat Fee' ? 'btn-danger': 'btn-outline-primary'" class="btn btn-custom d-flex justify-content-between btn-block align-items-center">
                                  <span>Flat Fee 
                                    <i class="fa fa-question-circle" data-toggle="tooltip" data-placement="top" title="A fixed amount charged for any transaction type done. E.g 10naira flat fee is set, it means even if user does 1 or 1000 naira transaction, it will always charge 10naira." aria-hidden="true"></i>
                                  </span>
                                  <img src="@/assets/TAJimages/arrow-down-icon-2.png" alt="">
                                </button>
                                <button @click="configType('percentage')" type="button" :class="isConfigType === 'percentage' ? 'btn-danger': 'btn-outline-primary'" class="btn btn-custom d-flex justify-content-between btn-block align-items-center mt-4">
                                  Percentage 
                                  <i class="fa fa-question-circle mr-2" style="margin-left:2px" data-toggle="tooltip" data-placement="top" title="This applies when percentage is set. You can put a limit to the charge to prevent really high charges. E.g  if you set 10% and some one does a 100k transaction. The charge will be 10k which is quite high. So you can put a limit to the charge and set it to 1000.. that way it won’t charge more than 1000" aria-hidden="true"></i>
                                <img src="@/assets/TAJimages/arrow-down-icon-2.png" alt="">
                                </button>
                            </div>
                         </div>
                     </div>
                 </div>
                 <div class="col-md-10">
                     <section v-if="isConfigType === 'Flat Fee'">
                         <!--config categories flat fee -->
                        <div v-for="config in updatedFlatFee.length === 0 ? configCategories : updatedFlatFee" :key="config.id">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex align-items-center flex-wrap">
                                        <div class="d-flex align-items-center mr-auto">
                                            <div class="flex-shrink-0">
                                                <img :src="config.icon" class="mr-3 img-fluid" alt="">
                                            </div>
                                            <div class="flex-grow-1 ms-3">
                                                <h5 class="config-text">{{config.transactionType === 1 ? 'Funds Transfer' : config.transactionType === 2 ? 'Bills Payment' : 'Airtime'}}</h5>
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <h6 class="config-amount-text">Configuration Amount:</h6>
                                            <input type="text" @paste.prevent @keyup="formatNum($event, config.id)" @keypress="isNumber" v-model="config.value" style="width:200px" class="form-control ml-3" placeholder="Enter Amount">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="footer-section" v-if="userSaveSpendLength >= 1">
                            <!-- <input style="background-color: red;" type="checkbox" class="mr-3" value="check"/>Disable save as you spend if he has insufficient fund during the course of a transaction &nbsp;<br /><br /> -->
                            <div class="button-section text-center pt-3 pb-5">
                                <router-link to="/save-as-you-spend/index">
                                    <button type="button" class="btn btn-primary px-5">Back</button>
                                </router-link>
                                <button type="button" data-toggle="modal" @click="setFlatConfig" data-target="#transactionPin" class="btn btn-warning ml-4">Save Config</button>
                            </div>
                        </div>
                     </section>
                     <section v-if="isConfigType === 'percentage'">
                        <!--configuration for percentage -->
                        <div class="card" v-for="config in updatedPercentage.length === 0 ? configCategoriesPercent : updatedPercentage" :key="config.id">
                            <div class="card-body">
                                <div class="d-flex align-items-center justify-content-between flex-wrap">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-shrink-0">
                                            <img :src="config.icon" class="mr-3 img-fluid" alt="">
                                        </div>
                                        <div class="flex-grow-1 ms-3">
                                            <h5 class="config-text">{{config.transactionType === 1 ? 'Funds Transfer' : config.transactionType === 2 ? 'Bills Payment' : 'Airtime'}}</h5>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <h6 class="config-amount-text mt-2">Percentage <i class="fa fa-question-circle" data-toggle="tooltip" data-placement="top" title="This applies when percentage is set. You can put a limit to the charge to prevent really high charges. E.g  if you set 10% and some one does a 100k transaction. The charge will be 10k which is quite high. So you can put a limit to the charge and set it to 1000.. that way it won’t charge more than 1000" aria-hidden="true"></i></h6>
                                        <input v-model="config.value" @paste.prevent @keypress="isNumber" maxlength="3" max="100" type="text" style="width:50px" class="form-control ml-3" placeholder="0%">
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <h6 class="config-amount-text mt-2">Minimum Amount <i class="fa fa-question-circle" data-toggle="tooltip" data-placement="top" title="The lower amount of the transaction band. E.g 10-100. The minimum is the lower amount where it starts from which is 10. Basically the from amount." aria-hidden="true"></i></h6>
                                        <input v-model="config.minimumAmount" @keyup="formatMinAmount($event, config.id)" type="text" style="width:80px" @paste.prevent autocomplete="off" @click="preventAuto" id="prevent-auto" class="form-control ml-3" placeholder="0.00">
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <h6 class="config-amount-text mt-2">Maximum Amount <i class="fa fa-question-circle" data-toggle="tooltip" data-placement="top" title="The highest amount in the transaction band. E.g 10-100. the maximum amount is the highest amount in the transaction bound. In this case it is 100." aria-hidden="true"></i></h6>
                                        <input v-model="config.maximumAmount" @keyup="formatMaxAmount($event, config.id)" @paste.prevent @keypress="isNumber" @click="removeReadonly" autocomplete="off" id="no-paste" type="text" style="width:80px" class="form-control ml-3" placeholder="0.00">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="footer-section" v-if="userSaveSpendLength >= 1">
                            <!-- <input style="background-color: red;" type="checkbox" class="mr-3" value="check"/>Disable save as you spend if he has insufficient fund during the course of a transaction &nbsp;<br /><br /> -->
                            <div class="button-section text-center pt-3 pb-5">
                                <router-link to="/save-as-you-spend/index">
                                    <button type="button" class="btn btn-primary px-5">Back</button>
                                </router-link>
                                <button type="button" @click="setPercentConfig" data-toggle="modal" data-target="#transactionPin" class="btn btn-warning ml-4">Save Config</button>
                            </div>
                        </div>
                     </section>
                 </div>
             </div>
            </section>
            <!-- transaction pin modal -->
            <div class="modal fade" id="transactionPin" tabindex="-1" role="dialog" aria-labelledby="pin" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title pl-2" id="pin" style="font-size: 18px">Transaction Pin</h5>
                        <button class="close text-dark" type="button" @click="closeTransModal" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                        <div class="modal-body p-4">
                            <section>
                                <div class="mb-3 row">
                                    <label class="col-sm-12 col-form-label" for="Purpose">Transaction Pin *</label>
                                    <div class="col-sm-12 col-xl-12">
                                        <input @paste.prevent @keypress="isNumber" v-model="form.transactionPin" maxlength="4" class="form-control" placeholder="Enter Transaction Pin" :type="type" />
                                        <span @click="showPin" class="pull-right show-pin">{{type === 'password' ? 'show' : 'hide'}}</span>
                                    </div>
                                </div>
                            </section>
                            <div class="text-center mt-4">
                              <button type="button" class="btn btn-danger" @click="closeTransModal">Cancel</button>
                              <button class="btn btn-warning ml-3" @click="editSaveAsYouSpend" type="button">
                                <div v-if="loader">
                                    <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                                  </div>
                                <div v-else>Save Config</div>
                              </button>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
  import { mapState } from 'vuex';
  import $ from 'jquery';
  // import comingSoon from '@/components/coming-soon.vue';
  export default {
    components: {
      // comingSoon
    },
    data:() => ({
      isConfigType: 'Flat Fee',
      showModal: false,
      value: {},
      loading: false,
      loader: false,
      type: 'password',
      form: {
        accountNumber: '',
        configurations: [],
        transactionPin: '',
        platform: 1,
      },
      config: {
        isFlat: true,
        value: '0.00',
        maximumAmount: 0,
        minimumAmount: 0,
        transactionType: 1,
        status: 1,
      },
      updatedPercentage: [],
      updatedFlatFee: [],
      configCategoriesIcons: [
        { icon: require('@/assets/TAJimages/funds-icon.png') },
        { icon: require('@/assets/TAJimages/bills-icon.png') },
        { icon: require('@/assets/TAJimages/airtime-icon.png') },
      ],
      configCategories: [
        { id: 1, name: 'Funds Transfer', value: '0.00', maximumAmount: '0.00', minimumAmount: '0.00', icon: require('@/assets/TAJimages/funds-icon.png'), isFlat: true, transactionType: 1, status: 1, },
        { id: 2, name: 'Bills Payment', value: '0.00', maximumAmount: '0.00', minimumAmount: '0.00', icon: require('@/assets/TAJimages/bills-icon.png'), isFlat: true, transactionType: 2, status: 1, },
        { id: 3, name: 'Airtime', value: '0.00', maximumAmount: '0.00', minimumAmount: '0.00', icon: require('@/assets/TAJimages/airtime-icon.png'), isFlat: true, transactionType: 3, status: 1, },
      ],
      configCategoriesPercent: [
        { id: 1, name: 'Funds Transfer', value: '', maximumAmount: '0.00', minimumAmount: '0.00', icon: require('@/assets/TAJimages/funds-icon.png'), isFlat: false, transactionType: 1, status: 1, },
        { id: 2, name: 'Bills Payment', value: '', maximumAmount: '0.00', minimumAmount: '0.00', icon: require('@/assets/TAJimages/bills-icon.png'), isFlat: false, transactionType: 2, status: 1, },
        { id: 3, name: 'Airtime', value: '', maximumAmount: '0.00', minimumAmount: '0.00', icon: require('@/assets/TAJimages/airtime-icon.png'), isFlat: false, transactionType: 3, status: 1, },
      ],
    }),
    computed: {
      ...mapState({
        account: state => state.dashboard.dashboardData,
        getUserSaveAsYouSpend: state => state.saveAsYouSpend.getUserSaveAsYouSpend.sort((a, b) => a.transactionType - b.transactionType),
      }),
      userSaveSpendLength() {
        return this.getUserSaveAsYouSpend ? this.getUserSaveAsYouSpend.length : 0;
      },
      userAccounts(){
        return this.account ? this.account.accounts : null;
      },
      getFirstAccount() {
        return this.userAccounts[0];
      }
    },
    mounted() {
      this.loading = true;
      this.$store.dispatch('dashboard/getDashboardData').then(response => {
        if(response.status === 200) {
          this.fetchSaveSpend(this.getFirstAccount.accountNumber);
          this.loading = false;
          this.value = this.getFirstAccount;
          this.form.accountNumber = this.value.accountNumber;
        }
      });
    },
    methods: {
      showPin() {
        this.type = this.type === 'password' ? 'text' : 'password';
      },
      preventAuto(){
        document.getElementById('prevent-auto').removeAttribute('readonly');
      },
      closeTransModal() {
        $('#transactionPin').modal('hide');
        this.form.transactionPin = '';
      },
      configType(val) {
        this.isConfigType = val;
      },
      fetchSaveSpend(data) {
        this.$store.commit('saveAsYouSpend/getUserSaveAsYouSpend', []);
        this.updatedPercentage = [];
        this.updatedFlatFee = [];
        this.$store.dispatch('saveAsYouSpend/getSaveAsYouSpend', data).then(response => {
          if(response.status === 200) {
            this.$store.commit('saveAsYouSpend/getUserSaveAsYouSpend');
            const savings = this.getUserSaveAsYouSpend.map((item, index) => index);
            const icons = this.configCategoriesIcons.map((item, index) => index);
            savings.forEach(item => {
              return icons.map((value, index)=> {
                if(item === index) {
                  this.getUserSaveAsYouSpend[item].icon = this.configCategoriesIcons[value].icon;
                }
              });
            });
            const updatedConfig = this.getUserSaveAsYouSpend.map(item => {
              if (item.isFlat) {
                return {
                  id: item.id,
                  value: new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(item.value),
                  icon: item.icon,
                  isFlat: item.isFlat,
                  transactionType: item.transactionType,
                  status: item.status,
                };
              } else {
                return {
                  id: item.id,
                  value: item.value,
                  maximumAmount: new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(item.maximumAmount),
                  minimumAmount: new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(item.minimumAmount),
                  icon: item.icon,
                  isFlat: item.isFlat,
                  transactionType: item.transactionType,
                  status: item.status,
                };
              }
            });
            updatedConfig.map(item => {
              if (item.isFlat) {
                this.updatedFlatFee.push(item);
              } else {
                this.updatedPercentage.push(item);
              }
            });
          }
        });
      },
      selectAccount(account) {
        this.value = account;
        this.showModal = false;
        this.form.accountNumber = account.accountNumber;
        this.fetchSaveSpend(account.accountNumber);
      },
      formatNum(event, id) {
        if(this.updatedFlatFee.length > 0) {
          this.updatedFlatFee.map((item, index) => {
            if(item.value === '') {
              item.value = '0.00';
            }
            if(item.id === id) {
              this.updatedFlatFee[index].value = event.target.value;
              const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
              this.updatedFlatFee[index].value = formatter.format(this.updatedFlatFee[index].value.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
              if(event.key === 'Backspace' || event.key === 'Delete') {
                if(event.target.value.length <= 4) {
                  const formatter = new Intl.NumberFormat('en-US');
                  this.updatedFlatFee[index].value = formatter.format(this.updatedFlatFee[index].value.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
                  if(event.target.value.length < 2) {
                    this.updatedFlatFee[index].value = '0.00';
                  }
                } else {
                  this.updatedFlatFee[index].value = event.target.value;
                  const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
                  this.updatedFlatFee[index].value = formatter.format(this.updatedFlatFee[index].value.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
                  return;
                }
              }
            }
          });
        } else {
          this.configCategories.map((item, index) => {
            if(item.value === '') {
              item.value = '0.00';
            }
            if(item.id === id) {
              this.configCategories[index].value = event.target.value;
              const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
              this.configCategories[index].value = formatter.format(this.configCategories[index].value.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
              if(event.key === 'Backspace' || event.key === 'Delete') {
                if(event.target.value.length <= 4) {
                  const formatter = new Intl.NumberFormat('en-US');
                  this.configCategories[index].value = formatter.format(this.configCategories[index].value.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
                  if(event.target.value.length < 2) {
                    this.configCategories[index].value = '0.00';
                  }
                } else {
                  this.configCategories[index].value = event.target.value;
                  const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
                  this.configCategories[index].value = formatter.format(this.configCategories[index].value.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
                  return;
                }
              }
            }
          });
        }
        
      },
      formatMinAmount(event, id) {
        if(this.updatedPercentage.length > 0) {
          this.updatedPercentage.map((item, index) => {
            if(item.id === id) {
              this.updatedPercentage[index].minimumAmount = event.target.value;
              const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
              this.updatedPercentage[index].minimumAmount = formatter.format(this.updatedPercentage[index].minimumAmount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
              if(event.key === 'Backspace' || event.key === 'Delete') {
                if(event.target.value.length <= 4) {
                  const formatter = new Intl.NumberFormat('en-US');
                  this.updatedPercentage[index].minimumAmount = formatter.format(this.updatedPercentage[index].minimumAmount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
                  if(event.target.value.length < 2) {
                    this.updatedPercentage[index].minimumAmount = '0.00';
                  }
                } else {
                  this.updatedPercentage[index].minimumAmount = event.target.value;
                  const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
                  this.updatedPercentage[index].minimumAmount = formatter.format(this.updatedPercentage[index].minimumAmount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
                  return;
                }
              }
            }
          });
        } else {
          this.configCategoriesPercent.map((item, index) => {
            if(item.id === id) {
              this.configCategoriesPercent[index].minimumAmount = event.target.value;
              const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
              this.configCategoriesPercent[index].minimumAmount = formatter.format(this.configCategoriesPercent[index].minimumAmount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
              if(event.key === 'Backspace' || event.key === 'Delete') {
                if(event.target.value.length <= 4) {
                  const formatter = new Intl.NumberFormat('en-US');
                  this.configCategoriesPercent[index].minimumAmount = formatter.format(this.configCategoriesPercent[index].minimumAmount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
                  if(event.target.value.length < 2) {
                    this.configCategoriesPercent[index].minimumAmount = '0.00';
                  }
                } else {
                  this.configCategoriesPercent[index].minimumAmount = event.target.value;
                  const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
                  this.configCategoriesPercent[index].minimumAmount = formatter.format(this.configCategoriesPercent[index].minimumAmount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
                  return;
                }
              }
            }
          });
        }
      },
      formatMaxAmount(event, id) {
        if(this.updatedPercentage.length > 0) {
          this.updatedPercentage.map((item, index) => {
            if(item.id === id) {
              this.updatedPercentage[index].maximumAmount = event.target.value;
              const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
              this.updatedPercentage[index].maximumAmount = formatter.format(this.updatedPercentage[index].maximumAmount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
              if(event.key === 'Backspace' || event.key === 'Delete') {
                if(event.target.value.length <= 4) {
                  const formatter = new Intl.NumberFormat('en-US');
                  this.updatedPercentage[index].maximumAmount = formatter.format(this.updatedPercentage[index].maximumAmount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
                  if(event.target.value.length < 2) {
                    this.updatedPercentage[index].maximumAmount = '0.00';
                  }
                } else {
                  this.updatedPercentage[index].maximumAmount = event.target.value;
                  const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
                  this.updatedPercentage[index].maximumAmount = formatter.format(this.updatedPercentage[index].maximumAmount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
                  return;
                }
              }
            }
          });
        } else {
          this.configCategoriesPercent.map((item, index) => {
            if(item.id === id) {
              this.configCategoriesPercent[index].maximumAmount = event.target.value;
              const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
              this.configCategoriesPercent[index].maximumAmount = formatter.format(this.configCategoriesPercent[index].maximumAmount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
              if(event.key === 'Backspace' || event.key === 'Delete') {
                if(event.target.value.length <= 4) {
                  const formatter = new Intl.NumberFormat('en-US');
                  this.configCategoriesPercent[index].maximumAmount = formatter.format(this.configCategoriesPercent[index].maximumAmount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
                  if(event.target.value.length < 2) {
                    this.configCategoriesPercent[index].maximumAmount = '0.00';
                  }
                } else {
                  this.configCategoriesPercent[index].maximumAmount = event.target.value;
                  const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
                  this.configCategoriesPercent[index].maximumAmount = formatter.format(this.configCategoriesPercent[index].maximumAmount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
                  return;
                }
              }
            }
          });
        }
      },
      setFlatConfig() {
        if (this.updatedFlatFee.length > 0) {
          const configArray = this.updatedFlatFee;
          const formatArray = configArray.map(item => {
            return {
              isFlat: item.isFlat,
              value: Number(item.value.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')),
              transactionType: item.transactionType,
              status: item.status,
            };
          });
          this.form.configurations = formatArray;
        } else {
          const configFlatArray = this.configCategories;
          const formatFlatArray = configFlatArray.map(item => {
            return {
              isFlat: item.isFlat,
              value: Number(item.value.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')),
              transactionType: item.transactionType,
              status: item.status,
            };
          });
          this.form.configurations = formatFlatArray;
        }
      },
      setPercentConfig(){
        if(this.updatedPercentage.length > 0) {
          const configPercArray = this.updatedPercentage;
          const formatPercArray = configPercArray.map(item => {
            return {
              isFlat: item.isFlat,
              value: Number(item.value),
              minimumAmount: Number(item.minimumAmount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')),
              maximumAmount: Number(item.maximumAmount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')),
              transactionType: item.transactionType,
              status: item.status,
            };
          });
          this.form.configurations = formatPercArray;
        }else {
          const configArray = this.configCategoriesPercent;
          const formatArray = configArray.map(item => {
            return {
              isFlat: item.isFlat,
              value: Number(item.value.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')),
              minimumAmount: Number(item.minimumAmount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')),
              maximumAmount: Number(item.maximumAmount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')),
              transactionType: item.transactionType,
              status: item.status,
            };
          });
          this.form.configurations = formatArray;
        }
      },
      editSaveAsYouSpend() {
        if(this.form.transactionPin === '' || this.form.configurations.length < 1) {
          this.$swal({
            title: 'Error!',
            text: 'Please fill in all fields',
            type: 'error',
            confirmButtonText: 'Ok'
          });
        } else {
          this.loader = true;
          this.$store.dispatch('saveAsYouSpend/createSaveAsYouSpend', this.form).then(response => {
            if(response.status === 200) {
              this.loader = false;
              this.$swal({
                title: 'Success!',
                text: 'Configuration Updated successfully',
                type: 'success',
                confirmButtonText: 'Ok'
              }).then(() => {
                this.$router.push({ name: 'save-as-you-spend' });
                $('#transactionPin').modal('hide');
              });
            }
          }).catch(error => {
            this.loader = false;
            this.$swal({
              title: 'Oops!',
              text: error.response.data.errors[0],
              type: 'error',
              confirmButtonText: 'Ok'
            });
          });
        }
      },
    }
  };
</script>
<style scoped>
.card .card-body {
    padding: 20px;
}
.card {
    border-radius: 10px;
}
.group-btn {
  width: 100%;
}
.account-section {
  display: flex;
  justify-content: space-between;
  width: 95%;
  background: #fff;
  border-radius: 10px;
  padding: 13px 20px;
  margin-left: 40px;
  cursor: pointer;
  align-items: center;
  /* margin-left: 40px; */
  cursor: pointer;
  flex-direction: row;
}
.badge-custom {
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  color: #5B93FF80;
  background: #5B93FF10;
  opacity: 1;
}
.header-text {
  font-size: 20px;
  line-height: 23px;
   color: #000000;
}
.header-subtext {
    font-weight: 400;
    font-size: 14px;
    line-height: 25px;
    color: #030229;
    opacity: 0.7;
    letter-spacing: 0;
    margin: 20px 0px;
}
.total-text {
  font-weight: 800;
  font-size: 18px;
  line-height: 25px;
  color: #030229;
  opacity: 0.7
}
.total-amount {
  font-weight: 800;
  font-size: 22px;
  line-height: 30px;
  color: #030229;
  opacity: 0.7;
  margin-top: 23px;
  margin-bottom: 35px;
}
.card-wrapper {
  padding: 20px;
}
.title-text {
  font-weight: 800;
  font-size: 22px;
  line-height: 30px;
  color: #000000;
  opacity: 0.7;
}
.title-subtext {
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #030229;
  opacity: 0.7;
}
.config-text {
    font-weight: 800;
    font-size: 17px;
    line-height: 30px;
    color: #000000;
    opacity: 0.7;
}
.config-amount-text {
    font-weight: 600;
    font-size: 13px;
    line-height: 19px;
    color: #030229;
    opacity: 0.7;
}
.config-type-text {
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    color: #030229;
    opacity: 0.7;
    text-align: center;
}
.btn-outline-primary {
    border: 1px solid #ededed;
    color: #000000;
}
.side-controller {
  height: 500px;
}
.btn-custom {
    padding: 7px 12px !important;
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
.custom-modal {
    position: absolute;
    z-index: 1;
    right: 20px;
    opacity: 1;
    transition: all 1s;
}
.custom-modal-items {
    cursor: pointer;
    padding: 10px 15px;
}
.shadow-lg {
    width: 500px
  }
.custom-modal-items:hover {
    background: #E41617;
    color: #fff;
    padding: 10px;
}
@media (max-width: 768px) {
  .side-controller {
    height: 100%;
  }
  .shadow-lg {
    width: 100%
  }
  .account-section {
    flex-direction: column;
    margin-left: 0 !important;
    width: 100%
  }
}
</style>